import { useApolloClient } from '@apollo/client';

import {
  CollaborativeDocumentFragmentDoc,
  useCollaborativeDocumentUpdatedSubscription,
} from '@spotify/confidence-graphql';

export const useCollaborativeDocumentUpdates = () => {
  const client = useApolloClient();

  useCollaborativeDocumentUpdatedSubscription({
    onData: ({ data: result }) => {
      const document =
        result.data?.collaborativeDocumentUpdated?.collaborativeDocument;
      if (!document?.__typename || !document.name) return;

      client.cache.writeFragment({
        id: client.cache.identify(document),
        fragment: CollaborativeDocumentFragmentDoc,
        fragmentName: 'CollaborativeDocument',
        data: document,
      });
    },
  });
};
